
type CellProps = {
  children?: React.ReactNode;
  grow?: boolean;
  className?: string;
};

export const Cell = ({ children, className, grow = false }: CellProps) => {
  if (className == "FirstName" || className == "LastName" || className == "Status" || className == "Contribution") {
    return ( 
      <div className={'table-comp-cell-shorter'} style={{width: "80px", alignItems:"left"}}>
        {children}
      </div>
    )
  } else if (className == "Email") {
    return (
      <div className="table-comp-cell-email" style={{width: "220px", alignItems:"left"}}>{children}</div>
      // <div className={classnames("cell", className, { grow })}>{children}</div>
    );
  } else if (className == "Role") {
    return (
      <div className="table-comp-cell-role" style={{width: "180px"}}>{children}</div>
      // <div className={classnames("cell", className, { grow })}>{children}</div>
    );  
  } else if (className == "CRUD") {
    return (
      <div className="table-comp-cell-role" style={{width: "230px", alignItems:"left"}}>{children}</div>
      // <div className={classnames("cell", className, { grow })}>{children}</div>
    );  
  } else {
    return (
      <div className="table-comp-cell">{children}</div>
      // <div className={classnames("cell", className, { grow })}>{children}</div>
    );
  }
}


type TableProps = {
  children?: React.ReactNode;
  className?: string;
};

// Table
export const Table = ({ children, className }: TableProps) => {
    return ( 
      <div className={'table-comp'}>
        {children}
      </div>
      // <div className={classnames("table", className)}>
      //   {children}
      // </div>
    );
}

type RowProps = {
  children: React.ReactNode;
};

// Row
export const Row = ({ children }: RowProps) => {
  return <div className="table-comp-row">{children}</div>;
}